export default "__VITE_ASSET__04df54a0__"